import '@angular/common/locales/global/fr';
import '@angular/common/locales/global/ar';

import { ApplicationConfig, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authHttpInterceptorFn, provideAuth0 } from '@auth0/auth0-angular';
import { IconModule, icons } from '@welma-education/ui/components';
import { routes } from './routes';
import {
  API_URL,
  networkRetryInterceptor,
  withChunkLoadErrorRecovery,
} from '@welma-education/common';
import { environment, provideLgsConfiguration } from './environment';
import { getLocale, provideI18n } from '@welma-education/i18n';
import { provideErrorHandling } from '@welma-education/shared/errors';

export const appConfig: ApplicationConfig = {
  providers: [
    provideI18n(),
    provideRouter(routes, withComponentInputBinding(), withChunkLoadErrorRecovery()),
    provideAnimations(),
    provideHttpClient(withInterceptors([authHttpInterceptorFn, networkRetryInterceptor()])),
    {
      provide: LOCALE_ID,
      useValue: getLocale(),
    },
    {
      provide: API_URL,
      useValue: environment.apiURL,
    },
    importProvidersFrom(IconModule.register(icons)),
    provideAuth0({
      domain: environment.auth0.domain,
      clientId: environment.auth0.clientId,
      authorizationParams: {
        audience: environment.auth0.audience,
        redirect_uri: window.location.origin,
      },
      httpInterceptor: {
        allowedList: [`${environment.apiURL}/*`, `/api/*`],
      },
    }),
    provideLgsConfiguration(),
    provideErrorHandling(),
  ],
};
